import { CSSProperties } from "react";

interface GirlDesktopProps {
  style?: CSSProperties;
}

export default function HandHearth({ style }: GirlDesktopProps) {
  return (
    <svg viewBox="13 -0.06 784 659.74" style={style}>
      <g clipPath="url(#56544813d1)">
        <path
          fill="#fff6f5"
          d="M755.266 46.52c-24.192 2.816-35.575 21.898-35.11 46.644 1.453 66.504-7.61 142.223-44.043 196.906-14.261 21.375-31.43 35.575-52.09 52.618l28.118-53.915c8.843-16.949 2.257-37.89-14.692-46.707-16.953-8.875-37.863-2.289-46.707 14.66l-85.094 163.196c-79.152 109.496-29.753 239.035-29.753 239.035l122.175.555c.621-62.543 39.098-115.867 39.098-115.867 172.039-202.133 159.36-398.239 158.277-448.438-.62-29.324-16.054-51.5-40.18-48.687"
        ></path>
      </g>
      <g clipPath="url(#f82c93a7b0)">
        <path
          fill="#fff6f5"
          d="M54.746 46.52c24.207 2.816 35.563 21.898 35.098 46.644-1.453 66.504 7.61 142.223 44.043 196.906 14.261 21.375 31.43 35.575 52.09 52.618l-28.118-53.915c-8.843-16.949-2.289-37.89 14.692-46.707 16.953-8.875 37.863-2.289 46.707 14.66l85.125 163.196c79.12 109.496 29.754 239.035 29.754 239.035l-122.207.555c-.621-62.543-39.098-115.867-39.098-115.867C.797 341.512 13.461 145.406 14.547 95.207c.629-29.324 16.082-51.5 40.2-48.687"
        ></path>
      </g>
      <path
        fill="#f45c65"
        d="M571.656 96.875c0-53.54-43.363-96.937-96.906-96.937-32.074 0-60.5 15.59-78.133 39.593-17.66-24.004-46.086-39.593-78.164-39.593-53.508 0-96.906 43.398-96.906 96.937 0 25.89 10.176 49.398 26.726 66.781L392.102 309.56l159.234-153.293c12.71-16.426 20.32-37.028 20.32-59.391"
      ></path>
    </svg>
  );
}
